// เอกสารของแคมเปญ
//
// อัปโหลดส่ง File เป็น body ตรง ๆ (ไม่ใช่ FormData) ให้ตรงกับฝั่ง server ที่รับ
// binary ล้วน — ชื่อไฟล์กับสวิตช์พรีวิวไปทาง query, ชนิดไฟล์ไปทาง Content-Type
import { api } from "@shared/api/client";

/** หมวดของเมนู Finance — ตรงกับ FINANCE_CATEGORIES ฝั่ง server */
export type FinanceCategory = "master_plan" | "media_plan" | "tv_plan" | "other";

/** เมนูที่ไฟล์นี้อยู่ — เมนู Documents กับ Finance ใช้ตารางเดียวกันแต่ไม่เห็นของกันและกัน */
export type DocumentArea = "doc" | "finance";

export type CampaignDocument = {
  id: string;
  /** null = ยังไม่ได้ผูกกับแคมเปญ (Finance เลือกทีหลังได้) */
  campaignId: string | null;
  productCode: string | null;
  area: DocumentArea;
  category: FinanceCategory | null;
  name: string;
  mime: string;
  size: number;
  /** true = ถ้าเป็นรูป ให้โชว์ตัวรูปในหน้า · false = โชว์เป็นแถวไฟล์ */
  preview: boolean;
  uploadedBy: string | null;
  createdAt: string;
};

export const documentKeys = {
  byProduct: (product: string, area: DocumentArea = "doc") =>
    ["documents", "product", product, area] as const,
};

export async function fetchDocuments(
  product: string,
  area: DocumentArea = "doc",
): Promise<CampaignDocument[]> {
  const { data } = await api.get<CampaignDocument[]>("/documents", { params: { product, area } });
  return Array.isArray(data) ? data : [];
}

export async function uploadDocument(input: {
  campaignId?: string | null;
  productCode?: string;
  area?: DocumentArea;
  category?: FinanceCategory;
  file: File;
  preview: boolean;
}): Promise<CampaignDocument> {
  const { campaignId, productCode, area, category, file, preview } = input;
  const { data } = await api.post<CampaignDocument>("/documents", file, {
    params: {
      campaign: campaignId || undefined,
      product: productCode || undefined,
      area,
      category,
      name: file.name,
      preview: preview ? "1" : "0",
    },
    // File ว่าง ๆ type อาจเป็น "" — ปล่อยให้ server เดาเป็น octet-stream แทนที่จะส่งค่าว่าง
    headers: { "Content-Type": file.type || "application/octet-stream" },
  });
  return data;
}

export async function patchDocument(
  id: string,
  body: {
    name?: string;
    preview?: boolean;
    category?: FinanceCategory;
    /** "" = ถอดแคมเปญออก (ยังอยู่กับแบรนด์เดิม) */
    campaignId?: string;
  },
): Promise<CampaignDocument> {
  const { data } = await api.patch<CampaignDocument>(`/documents/${encodeURIComponent(id)}`, body);
  return data;
}

export async function deleteDocument(id: string): Promise<void> {
  await api.delete(`/documents/${encodeURIComponent(id)}`);
}

/**
 * URL ของตัวไฟล์ — ใช้กับ <img src>/<iframe src> และปุ่มดาวน์โหลดได้เลย
 * ไม่ผ่าน axios เพราะ browser ต้องโหลดเองผ่าน tag
 */
export function documentFileUrl(id: string, opts: { download?: boolean } = {}): string {
  const base = `/app-api/v1/documents/${encodeURIComponent(id)}/file`;
  return opts.download ? `${base}?download=1` : base;
}
